<template lang="pug">
component(
  v-if="component && $attrs.custom_field.id"
  :is="component"
  v-bind="$attrs"
  v-on="$listeners"
)
</template>
<script>
export default{
  data: ()=>({
    component: null
  }),
  computed:{
    html_type(){ return this.$attrs.custom_field.html_type }
  },
  watch: {
    html_type(){ this.loadComponent() }
  },
  created(){ this.loadComponent() },
  methods: {
    loadComponent(){
      import(`./custom_field/${this.html_type}.vue`).then(res=> this.component=res.default )
    },
  },
}
</script>
